import { IPage } from '@aon/aon-tws-common-ui';
import axios from 'axios';
import Constants from '../constants';
import { IDistributionContact } from '../models';

export function getDistributionContactsQuery(
	surveyId: number,
	audienceId: number,
	offSet: number,
	limit: number,
	sortedOn: string,
	sortAsc: boolean,
	searchText: string,
	extraColumns?: string[],
) {
	let params = `${Constants.SURVEY_BUILDER_SURVEYS_API_URL}/${surveyId}/audiences/${audienceId}/contacts`;
	params += `?offSet=${offSet}&limit=${limit}&sortedOn=${sortedOn}&sortAsc=${sortAsc}&searchText=${searchText}`;

	if (extraColumns && extraColumns.length > 0) {
		params += `&selectedColumns=${extraColumns}`;
	}
	return params;
}

export async function getDistributionContacts(
	surveyId: number,
	audienceId: number,
	offSet: number,
	limit: number,
	searchText: string,
	sortedBy: string,
	sortAsc: boolean,
	selectedColumns?: string[],
): Promise<IPage<IDistributionContact>> {
	const res = await axios.get(
		getDistributionContactsQuery(surveyId, audienceId, offSet, limit, sortedBy, sortAsc, searchText, selectedColumns),
		Constants.noCacheConfig,
	);

	return {
		pageRange: JSON.parse(res.headers.range),
		items: res.data,
	};
}

export async function deleteDistributionContact(surveyId: number, audienceId: number, distributionContactId: number): Promise<any> {
	const url = `${Constants.SURVEY_BUILDER_SURVEYS_API_URL}/${surveyId}/audiences` + `/${audienceId}/contacts/${distributionContactId}`;
	const res = await axios.delete(url);
	return res.data;
}

export async function deleteDistributionContacts(surveyId: number, audienceId: number, distributionContactIds: number[]): Promise<any> {
	const url = `${Constants.SURVEY_BUILDER_SURVEYS_API_URL}/${surveyId}/audiences` + `/${audienceId}/contacts`;
	const res = await axios.delete(url, { data: { audienceId, distributionContactIds } });
	return res.data;
}

export async function downloadDistributionContactExport(surveyId: number, audienceId: number, selectedContactIds: number[]): Promise<any> {
	const data = { selectedContactIds: selectedContactIds };
	const res = await axios.post(getdownloadDistributionContactExportQuery(surveyId, audienceId), data, {
		responseType: Constants.FileDownloadResponseType,
		timeout: Constants.FileDownloadTimeout,
		headers: Constants.excelResponseHeader,
	});
	return res.data;
}

export function getdownloadDistributionContactExportQuery(surveyId: number, audienceId: number) {
	return Constants.DISTRIBUTION_CONTACT_EXPORT.replace('{surveyId}', surveyId.toString()).replace('{audienceId}', audienceId.toString());
}

export function getPendingParticipantsQuery(surveyId: number) {
	return Constants.DISTRIBUTION_PENDING_PARTICIPANTS.replace('{surveyId}', surveyId.toString());
}

export async function getPendingParticipants(surveyId: number): Promise<IDistributionContact[]> {
	const res = await axios.get(getPendingParticipantsQuery(surveyId), Constants.noCacheConfig);
	return res.data.map((d: any) => d.distributionContact as IDistributionContact);
}

export async function savePendingParticipants(surveyId: number, contacts: IDistributionContact[]) {
	const res = await axios.post(getPendingParticipantsQuery(surveyId), contacts);
	return res.data;
}
